/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useSupportPageStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    height: '100%',
    width: '100%',
  },
  title: {
    marginTop: '5px',
    marginBottom: '20px',
  },
  emailConfirmation: {
    marginTop: '10px',
    marginRight: '0',
  },
  checkboxes: {
    display: 'flex',
    flexDirection: 'column',
  },
  submitBtn: {
    marginTop: '15px',
  },
}));
